// extracted by mini-css-extract-plugin
module.exports = {"explanation-card":"ExplanationCard_explanation-card__ohufa"};